<template>
  <div class="fullscreen">
    <div class="chatContainer">
      <div class="headContainer">
        <div class="serviceInfoWrapper">
          <div class="serviceAvatar">
            <img class="avatar" :src="serviceAvatar" alt />
          </div>
          <div class="serviceInfo">
            <div class="bigTitle">{{serviceName ? serviceName : noServiceTips}}</div>
            <div class="smallTitle" v-if="agent_sign">{{ agent_sign }}</div>
          </div>
        </div>
        <div class="handlerWrapper">
          <div class="handlerItem" v-if="!chatend && (loginInfo && loginInfo.agent_type ==='robot')" style="margin-right: 10px;">
            <span class="toHuman " @click="robotTurnManual">转人工</span>
          </div>
          <div class="handlerItem">
            <svg-icon v-if="voiceOn" icon-class="broadcast" @click.native="voiceToggle"></svg-icon>
            <svg-icon v-else icon-class="silence" @click.native="voiceToggle"></svg-icon>
          </div>
          <div class="handlerItem" style="margin-left: 6px;" @click="chatEndHandler" v-if="!chatend && alone == 1">
            <svg-icon icon-class="chatend" style="margin-right: 0;"></svg-icon>结束会话
          </div>
          <div class="handlerItem" v-if="chatType === 'model' " style="margin-left: 10px;">
            <svg-icon icon-class="modelClose" style="margin-right: 0;"></svg-icon>关闭
          </div>
        </div>
      </div>
      <div class="bottomContainer">
        <div class="leftContainer">
          <!-- 聊天开始 -->
          <div class="chat-container" v-if="chatShow === 'chat' || chatShow === 'viewHis'">
            <perfect-scrollbar style="flex: 1;">
              <div class="chat-main" ref="detailCont" id="chatMain">
                <div class="load-history" v-if="messageHistory && !isLoading">
                  <span @click="loadHistory">查看更多历史消息</span>
                </div>
                <div style="text-align: center;" v-if="isLoading">
                  <van-loading size="24px">加载中...</van-loading>
                </div>
                <div class="message-container" v-for="(msg, i) in messages" :key="i">
                  <!--          消息时间 start-->
                  <div class="msg-times" v-if="$utils.msgTimeRender(msg.sendtime)">
                    <span>{{$utils.msgTimeRender(msg.sendtime)}}</span>
                  </div>
                  <!--          消息时间 end-->
                  <!--          系统消息 start-->
                  <div class="event-msg msg-item" v-if="msg.role === 'event'">
                    <span v-html="msg.text"></span>
                  </div>
                  <!--          系统消息 end-->
                  <!--          客服消息 start-->
                  <div v-if="msg.role === 'agent'" class="agent-msg msg-item clearfix">
                    <div class="chat-avatar" v-if="false">
                      <img class="avatar" :src="msg.agent_avatar" alt />
                    </div>
                    <div class="chat-content">
                      <div class="msg-time">{{msg.agent_nickname}}</div>
                      <div class="msg-content">
                        <div
                          v-if="msg.isCsReply == 1"
                          style="color: #999;padding-bottom: 6px;font-size: 12px;"
                        >{{msg.visitorName}}</div>
                        <div
                          v-if="msg.isCsReply == 1"
                          style="color: #999;padding: 0 8px 5px;box-sizing: border-box;border-bottom: 1px solid #ddd;margin-bottom: 5px;"
                         v-html="msg.csReplyText"></div>
                        <div class="textMsg" v-if="msg.msg_type === 'text'">
                          <span
                            v-if="msg.isCsReply == 1"
                            style="color: #333;padding-left: 5px;box-sizing: border-box;"
                          >回复：</span>
                          <span v-html="$utils.renderUrl(formatTrendEmoji(msg.text))"></span>
                          <div class="reply-operate" v-if="msg.libType!=0 && msg.handler" v-html="msg.handler"></div>
                        </div>
                        <div class="imgMsg" v-if="msg.msg_type === 'image'">
                          <a :href="msg.text" target="_blank">
                            <img :src="msg.text" alt />
                          </a>
                        </div>
                        <div
                          class="voiceMsg"
                          @click="voicePlay($event)"
                          v-if="msg.msg_type === 'voice'"
                        >
                          <audio class="audioId" preload="auto" hidden="true" index="1" ref="audio">
                            <source :src="msg.text" type="audio/mpeg" />
                          </audio>
                          <div class="wifi-symbol voice-agent">
                            <div class="wifi-circle first"></div>
                            <div class="wifi-circle second" ref="second"></div>
                            <div class="wifi-circle third" ref="third"></div>
                          </div>
                          <span>{{msg.talk_time}}''</span>
                        </div>
                        <div class="videoMsg" v-if="msg.msg_type === 'video'">
                          <video
                            class="videoId"
                            preload
                            controls
                            controlslist="nodownload"
                            :poster="msg.reduced_graph"
                            @click="videoStop($event)"
                          >
                            <source :src="msg.text" type="video/mp4" />
                          </video>
                          <div class="video-mask">
                            <svg-icon
                              class="playBtn"
                              icon-class="videoplay"
                              @click.native="videoPlay($event)"
                            ></svg-icon>
                          </div>
                        </div>
                        <div class="fileMsg" v-if="msg.msg_type === 'file'">
                          <svg-icon icon-class="file"></svg-icon>
                          <span>{{msg.text.split(',')[0]}}</span>
                          <a
                            class="view-file"
                            target="_blank"
                            :href="msg.text.split(',')[1]"
                            download
                          >查看文件</a>
                        </div>
                        <div class="goodMsg" v-if="msg.msg_type === 'goods'">
                          <div class="send-goods-box">
                            <a
                              :href="JSON.parse(msg.text).link"
                              target="_blank"
                              class="clearfix send-goods-info-box"
                            >
                              <div class="fl send-goods-image">
                                <img :src="JSON.parse(msg.text).img" alt="商品图" />
                              </div>
                              <div class="fl send-goods-info">
                                <div class="send-goods-title">
                                  {{JSON.parse(msg.text).title.length > 30 ?
                                  JSON.parse(msg.text).title.slice(0, 29)+'...' : JSON.parse(msg.text).title}}
                                </div>
                                <div class="send-goods-price">
                                  ¥
                                  <span>{{JSON.parse(msg.text).price}}</span>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div class="couponMsg" v-if="msg.msg_type === 'coupon'">
                          <a
                            :href="JSON.parse(msg.text).link"
                            target="_blank"
                            class="coupon-container clearfix"
                          >
                            <div class="coupon-image fl">
                              <img src="@/assets/images/coupon.png" alt />
                            </div>
                            <div class="coupon-content fl">
                              <div class="coupon-title">
                                {{JSON.parse(msg.text).title.length > 30 ?
                                JSON.parse(msg.text).title.slice(0, 29)+'...' : JSON.parse(msg.text).title}}
                              </div>
                              <div class="coupon-desc">
                                {{JSON.parse(msg.text).start_time | formateDateTime}} -
                                {{JSON.parse(msg.text).end_time | formateDateTime}}
                              </div>
                              <div class="coupon-price">{{JSON.parse(msg.text).price}}</div>
                            </div>
                          </a>
                        </div>
                        <div class="expressMsg" v-if="msg.msg_type === 'express'">
                          <div class="express-container">
                            <div class="order-no-type clearfix">
                              <div class="order-no fl">
                                <span>订单编号：</span>
                                <span>{{JSON.parse(msg.text).order_no}}</span>
                              </div>
                              <div
                                class="order-type fr"
                                :class="renderOrderStatusClass(JSON.parse(msg.text).status)"
                              >
                                <span>{{renderOrderStatus(JSON.parse(msg.text).status)}}</span>
                              </div>
                            </div>
                            <a
                              :href="JSON.parse(msg.text).link"
                              target="_blank"
                              class="order-container clearfix"
                            >
                              <div class="order-goods-image fl">
                                <img :src="JSON.parse(msg.text).img" alt="商品" />
                              </div>
                              <div class="order-goods-info fl">
                                <div class="order-goods-title">
                                  {{JSON.parse(msg.text).title.length > 40 ?
                                  JSON.parse(msg.text).title.slice(0, 39)+'...' : JSON.parse(msg.text).title}}
                                </div>
                                <div class="order-goods-price">¥ {{JSON.parse(msg.text).price}}</div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div class="orderInfoMsg" v-if="msg.msg_type === 'orderInfo'">
                          <div class="order-msg-title">当前交易 ({{JSON.parse(msg.text).data.number}})</div>
                          <div class="order-msg-goods-container clearfix">
                            <div class="order-goods-img">
                              <img :src="JSON.parse(msg.text).data.goods[0].imgUrls" alt="商品图" />
                            </div>
                            <div class="order-goods-detail">
                              <div
                                class="order-goods-name"
                              >{{JSON.parse(msg.text).data.goods[0].title}}</div>
                              <div class="order-goods-count">
                                共{{JSON.parse(msg.text).data.goods.length}}件商品,
                                合计￥{{JSON.parse(msg.text).data.total_price}}
                              </div>
                            </div>
                          </div>
                          <div class="order-msg-addr">
                            <div class="addr-item clearfix">
                              <div class="label-name">姓名：</div>
                              <div
                                class="label-content"
                              >{{JSON.parse(msg.text).data.consignee_name}}</div>
                            </div>
                            <div class="addr-item clearfix">
                              <div class="label-name">电话：</div>
                              <div
                                class="label-content"
                              >{{JSON.parse(msg.text).data.consignee_phone}}</div>
                            </div>
                            <div class="addr-item clearfix">
                              <div class="label-name">地址：</div>
                              <div
                                class="label-content"
                              >{{JSON.parse(msg.text).data.consignee_address}}</div>
                            </div>
                          </div>
                          <div class="order-msg-operate clearfix">
                            <div
                              v-if="JSON.parse(msg.text).flag === '1' && JSON.parse(msg.text).data.refunding_url != ''"
                            >
                              <a :href="JSON.parse(msg.text).data.refunding_url">退货</a>
                            </div>
                            <div
                              v-if="JSON.parse(msg.text).flag === '1' && JSON.parse(msg.text).data.exchange_url != ''"
                            >
                              <a :href="JSON.parse(msg.text).data.exchange_url">换货</a>
                            </div>
                            <div v-if=" msg.agent_type === 'robot'">
                              <span class="toHuman " @click="robotTurnManual">人工客服</span>
                            </div>
                          </div>
                        </div>
                        <div class="placeOrderMsg" v-if="msg.msg_type === 'place_order'">
                          <div v-if="JSON.parse(msg.text).status == 0" class="orderTitle">亲，您有一笔订单未付款~</div>
                          <div v-else class="orderTitle">亲，请您核对订单信息</div>
                          <a :href="JSON.parse(msg.text).orderUrl" class="orderGood-container">
                            <div class="goods-image">
                              <img :src="JSON.parse(msg.text).image" alt />
                            </div>
                            <div class="goods-detail">
                              <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                              <div
                                class="goods-order-detail"
                              >共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
                            </div>
                          </a>
                          <div class="addressInfo" v-if="JSON.parse(msg.text).status != 0">
                            <span class="label">地址：</span>
                            <span class="detail">{{JSON.parse(msg.text).receiverAddress}}</span>
                          </div>
                          <div v-if="JSON.parse(msg.text).status == 1">
                            <div
                              class="operation-btn"
                              style="border-top: 1px solid #eee;margin-top: 5px;"
                              v-if="initialData.is_open_modify_address == 1"
                            >
                              <span
                                v-if="JSON.parse(msg.text).addressState == 0"
                                class="editBtn"
                                @click="editAddr(JSON.parse(msg.text).orderId, JSON.parse(msg.text).callingId)"
                              >修改</span>
                              <span
                                v-if="JSON.parse(msg.text).addressState == 0"
                                class="confirmBtn"
                                @click="confirmAddr(JSON.parse(msg.text).orderId, JSON.parse(msg.text).callingId,1, JSON.parse(msg.text).receiverAddress)"
                              >确认</span>
                              <span
                                v-if="JSON.parse(msg.text).addressState == 1"
                                style="display: inline-block;text-align: center;color: #999;width: 100%;"
                              >已确认</span>
                            </div>
                            <div
                              class="operation-btn"
                              style="border-top: 1px solid #eee;margin-top: 5px;"
                              v-if="initialData.is_open_modify_address == 0"
                            >
                              <a
                                style="display: inline-block;"
                                :href="JSON.parse(msg.text).orderUrl"
                              >查看订单</a>
                            </div>
                          </div>
                          <div
                            class="operation-btn"
                            style="border-top: 1px solid #eee;margin-top: 5px;"
                            v-if="JSON.parse(msg.text).status == 0"
                          >
                            <a
                              style="display: inline-block;"
                              :href="JSON.parse(msg.text).orderUrl"
                            >去付款</a>
                          </div>
                        </div>
                        <div class="arrivalMsg" v-if="msg.msg_type === 'arrival_notice'">
                          <div class="orderTitle">验收提醒</div>
                          <a :href="JSON.parse(msg.text).orderUrl" class="orderGood-container">
                            <div class="goods-image">
                              <img :src="JSON.parse(msg.text).image" alt />
                            </div>
                            <div class="goods-detail">
                              <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                              <div
                                class="goods-order-detail"
                              >共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
                            </div>
                          </a>
                          <div class="deliveryTips">{{JSON.parse(msg.text).acceptanceMsg}}</div>
                          <div class="operation-btn">
                            <a :href="JSON.parse(msg.text).orderUrl">查看订单</a>
                          </div>
                        </div>
                        <div class="deliveryMsg" v-if="msg.msg_type === 'delivery_notice'">
                          <div class="orderTitle">订单已发货</div>
                          <a :href="JSON.parse(msg.text).orderUrl" class="orderGood-container">
                            <div class="goods-image">
                              <img :src="JSON.parse(msg.text).image" alt />
                            </div>
                            <div class="goods-detail">
                              <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                              <div
                                class="goods-order-detail"
                              >共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
                            </div>
                          </a>
                          <div
                            class="deliveryInfo"
                            v-if="showMore"
                            v-for="(item, i) in JSON.parse(msg.text).logistics"
                            :key="i"
                          >
                            <div class="deliveryInfo-item">
                              <div class="deliveryInfo-label">物流公司：</div>
                              <div class="deliveryInfo-detail">{{item.express}}</div>
                            </div>
                            <div class="deliveryInfo-item">
                              <div class="deliveryInfo-label">快递单号：</div>
                              <div class="deliveryInfo-detail">{{item.expressNo}}</div>
                            </div>
                          </div>
                          <div
                            class="deliveryInfo"
                            v-if="JSON.parse(msg.text).logistics[0] && !showMore"
                          >
                            <div class="deliveryInfo-item">
                              <div class="deliveryInfo-label">物流公司：</div>
                              <div
                                class="deliveryInfo-detail"
                              >{{JSON.parse(msg.text).logistics[0].express}}</div>
                            </div>
                            <div class="deliveryInfo-item">
                              <div class="deliveryInfo-label">快递单号：</div>
                              <div
                                class="deliveryInfo-detail"
                              >{{JSON.parse(msg.text).logistics[0].expressNo}}</div>
                            </div>
                          </div>
                          <div
                            style="text-align: center;font-size: 18px;padding-top: 3px;color: #ccc;"
                            v-if="JSON.parse(msg.text).logistics.length > 1 && !showMore"
                          >
                            <van-icon name="arrow-down" @click="showMore = true" />
                          </div>
                          <div class="operation-btn">
                            <a :href="JSON.parse(msg.text).orderUrl">查看订单</a>
                          </div>
                        </div>
                        <div class="refundMsg" v-if="msg.msg_type === 'refund_notice'">
                          <div class="orderTitle">退/换货申请已通过审核</div>
                          <div class="order-msg-no">订单编号：{{JSON.parse(msg.text).orderNo}}</div>
                          <a :href="JSON.parse(msg.text).orderUrl" class="orderGood-container">
                            <div class="goods-image">
                              <img :src="JSON.parse(msg.text).image" alt />
                            </div>
                            <div class="goods-detail">
                              <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                            </div>
                          </a>
                          <div class="refundInfo">
                            <p>共计 {{JSON.parse(msg.text).goodsNum}} 件商品</p>
                            <p>实际退款：￥{{JSON.parse(msg.text).payment}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--          客服消息 end-->

                  <!--          访客消息 start-->
                  <div class="client-msg msg-item clearfix" v-if="msg.role === 'client'">
                    <div class="chat-avatar" v-if="false">
                      我
                      <!--              <img class="avatar" :src="serviceAvatar" alt="">-->
                    </div>
                    <div class="chat-content" :class="whiteIconClass(msg.msg_type)">
                      <!--              <div class="msg-time">{{msg.sendtime}}</div>-->
                      <div
                        class="msg-content textMsg"
                        v-if="msg.msg_type === 'text'"
                        v-html="$utils.renderUrl(formatTrendEmoji(msg.text))"
                      ></div>
                      <div class="msg-content imgMsg" v-if="msg.msg_type === 'image'">
                        <a :href="msg.text" target="_blank">
                          <img :src="msg.text" alt />
                        </a>
                      </div>
                      <div
                        class="msg-content voiceMsg"
                        @click="voicePlay($event)"
                        v-if="msg.msg_type === 'voice'"
                      >
                        <audio class="audioId" preload="auto" hidden="true" index="2" ref="audio">
                          <source :src="msg.text" type="audio/mpeg" />
                        </audio>
                        <div class="wifi-symbol voice-client">
                          <div class="wifi-circle first"></div>
                          <div class="wifi-circle second" ref="second"></div>
                          <div class="wifi-circle third" ref="third"></div>
                        </div>
                        <span>{{msg.talk_time}}''</span>
                      </div>
                      <div class="msg-content videoMsg" v-if="msg.msg_type === 'video'">
                        <video
                          class="videoId"
                          preload
                          controls
                          controlslist="nodownload"
                          :poster="msg.reduced_graph"
                          @click="videoStop($event)"
                        >
                          <source :src="msg.text" type="video/mp4" />
                        </video>
                        <div class="video-mask">
                          <svg-icon
                            class="playBtn"
                            icon-class="videoplay"
                            @click.native="videoPlay($event)"
                          ></svg-icon>
                        </div>
                      </div>
                      <div class="msg-content fileMsg" v-if="msg.msg_type === 'file'">
                        <svg-icon icon-class="file"></svg-icon>
                        <span>{{msg.text.split(',')[0]}}</span>
                        <a
                          class="view-file"
                          target="_blank"
                          :href="msg.text.split(',')[1]"
                          download
                        >查看文件</a>
                      </div>
                      <div class="msg-content goodMsg" v-if="msg.msg_type === 'goods'">
                        <div class="send-goods-box">
                          <a
                            :href="JSON.parse(msg.text).link"
                            target="_blank"
                            class="clearfix send-goods-info-box"
                          >
                            <div class="fl send-goods-image">
                              <img :src="JSON.parse(msg.text).img" alt="商品图" />
                            </div>
                            <div class="fl send-goods-info">
                              <div class="send-goods-title">
                                {{JSON.parse(msg.text).title.length > 30 ?
                                JSON.parse(msg.text).title.slice(0, 29)+'...' : JSON.parse(msg.text).title}}
                              </div>
                              <div class="send-goods-price">
                                ¥
                                <span>{{JSON.parse(msg.text).price}}</span>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--          访客消息 end-->

                  <!--          访客发送商品消息 start-->
                  <div
                    v-if="msg.role === 'sendGoods' && msg.isShow === 'show' && showSendGoods"
                    class="msg-item send-goods-container"
                  >
                    <div class="send-goods-box">
                      <a class="clearfix send-goods-info-box">
                        <div class="fl send-goods-image">
                          <img :src="JSON.parse(msg.text).img" alt="商品图" />
                        </div>
                        <div class="fl send-goods-info">
                          <div class="send-goods-title">
                            {{JSON.parse(msg.text).title.length > 30 ?
                            JSON.parse(msg.text).title.slice(0, 29)+'...' : JSON.parse(msg.text).title}}
                          </div>
                          <div class="send-goods-price">
                            ¥
                            <span>{{JSON.parse(msg.text).price}}</span>
                          </div>
                        </div>
                      </a>
                      <div class="send-goods-btn-wrap">
                        <span class="send-goods-btn" @click="sendGoodsLink(msg.text)">发给客服</span>
                      </div>
                    </div>
                  </div>
                  <!--          访客发送商品消息 end-->
                </div>
              </div>
              <div style="height: 0;" class="scrollBottom"></div>
            </perfect-scrollbar>
            <div class="chat-bottom" v-if="chatShow ==='chat'">
               <div class="human-btn" v-if="isAiReply">
                <span class="toHuman" @click="transferToHuman">转人工</span>
              </div>
              <div v-if="chatWithService" class="chat-input-container chat-operate">
                <vue-emoji
                  class="emoji_pannel"
                  @selectedEmoji="selectEmoji"
                  v-show="showEmoji"
                  @click.native="stopPropagationFn($event)"
                ></vue-emoji>
                <div
                  class="wechat_contact"
                  v-if="showWechat && WechatImage"
                  @click="stopPropagationFn($event)"
                >
                  <div class="wechat_QRCode">
                    <img :src="WechatImage" alt />
                  </div>
                  <div class="close_wechat_contact">
                    <span @click="showWechat = false">关闭</span>
                  </div>
                </div>
                <input
                  type="file"
                  v-show="false"
                  @change="uploadImage"
                  accept="image/png, image/jpeg, image/gif, image/jpg"
                  ref="imgUpload"
                />
                <input type="file" v-show="false" @change="uploadFile" ref="fileUpload" />
                <input type="file" v-show="false" accept="video/*" @change="uploadVideo" ref="videoUpload" />
                <ul class="tools-bar clearfix">
                  <li>
                    <el-tooltip class="item" effect="dark" content="表情" placement="bottom">
                      <svg-icon icon-class="emoji" @click.native="showEmojiFn($event)"></svg-icon>
                    </el-tooltip>
                  </li>
                  <li v-if="WechatImage">
                    <el-tooltip class="item" effect="dark" content="微信咨询" placement="bottom">
                    <svg-icon icon-class="wechat" @click.native="showWechatFn($event)"></svg-icon>
                    </el-tooltip>
                  </li>
                  <li v-if="showQQIcon">
                    <el-tooltip class="item" effect="dark" content="QQ咨询" placement="bottom">
                    <a class="qq_contact" :href="QQUrl">
                      <svg-icon icon-class="qq"></svg-icon>
                    </a>
                    </el-tooltip>
                  </li>
                  <li v-if="initialData.is_upload">
                    <el-tooltip class="item" effect="dark" content="发送图片" placement="bottom">
                    <svg-icon icon-class="image" @click.native="imageClick"></svg-icon>
                    </el-tooltip>
                  </li>
                  <li v-if="initialData.is_upload">
                    <el-tooltip class="item" effect="dark" content="发送文件" placement="bottom">
                    <svg-icon icon-class="fileupload" @click.native="fileClick"></svg-icon>
                    </el-tooltip>
                  </li>
                  <li v-if="initialData.is_video">
                    <el-tooltip class="item" effect="dark" content="发送视频" placement="bottom">
                    <svg-icon icon-class="pcvideo" @click.native="videoClick"></svg-icon>
                    </el-tooltip>
                  </li>
                  <li v-if="initialData.is_evaluat">
                    <el-tooltip class="item" effect="dark" content="评价" placement="bottom">
                    <svg-icon icon-class="thumb" @click.native="toEvaluate"></svg-icon>
                    </el-tooltip>
                  </li>
                  <li class="recallStyle" v-if="initialData.calling_config&&initialData.calling_config.is_open_call_back==1">
                    <div class="recallTips" v-if="recallTipsShow">
                      <div>1.我们将立即回电</div>
                      <div style="color: orange;">2.该通话免费，放心接听</div>
                      <div>3.手机号请直接输入</div>
                      <div>4.座机前加区号</div>
                    </div>
                    <div>
                      <input
                        v-model="mobile"
                        class="recallInput"
                        @focus="recallTipsShow = true"
                        @blur="recallTipsShow = false"
                        type="text"
                        placeholder="请输入电话号码"
                      />
                      <span class="recallBtn" @click="subitPhone">给您回电</span>
                    </div>
                  </li>
                </ul>
                <div class="inputTextContainer">
                  <textarea
                    v-model="textarea"
                    @focus="focusEvent"
                    @blur="blurEvent"
                    id="chatTextarea"
                    @keypress="enterSendMsg($event)"
                    placeholder="请输入..."
                    class="chat-content chatTextDiv"
                  ></textarea>
                  <div
                    class="sendBtnContainer"
                    :class="sendActive ? 'btnActive' : ''"
                    @click="sendMsg"
                  >
                    <div>发送</div>
                  </div>
                </div>
                <div class="chat-send-operate-btn">
                  <span
                    style="font-size: 12px;color: #999;padding-right: 6px;"
                  >Enter发送，Ctrl + Enter换行</span>
                </div>
              </div>
              <div class="chat-end-container chat-operate" v-if="chatend">
                <ul
                  class="chat-end-operate clearfix"
                  :class="initialData.is_evaluat ? '' : 'no-evaluate' "
                >
                  <li v-if="initialData.is_evaluat">
                    <div>
                      <svg-icon
                        @click.native="toEvaluate"
                        icon-class="heart"
                        style="width: 30px;height: 30px;"
                      ></svg-icon>
                    </div>
                    <div class="chat-end-operate-title" @click="toEvaluate">满意度</div>
                  </li>
                  <li>
                    <div>
                      <svg-icon
                        @click.native="chatReload"
                        icon-class="chat"
                        style="width: 30px;height: 30px;"
                      ></svg-icon>
                    </div>
                    <div class="chat-end-operate-title" @click="chatReload">继续会话</div>
                  </li>
                  <li>
                    <div>
                      <svg-icon
                        @click.native="toLeaveMsg"
                        icon-class="leavemsg"
                        style="width: 30px;height: 30px;"
                      ></svg-icon>
                    </div>
                    <div @click="toLeaveMsg" class="chat-end-operate-title">留言</div>
                  </li>
                </ul>
              </div>
              <div class="chat-end-container chat-operate black-container" v-if="isBlack">
                <span>抱歉，客服系统暂时无法使用</span>
              </div>
            </div>
            <div class="evaluate-pannel" v-if="showEvaluatePannel && initialData.is_evaluat">
              <div class="evaluate-container">
                <div class="evaluate-title">
                  <div
                    style="width: 70%;margin: 15px auto 0;"
                    v-if="initialData.calling_config.evaluate_auto === '1'"
                  >{{initialData.calling_config.evaluate_content}}</div>
                  <svg-icon
                    @click.native="closeEvaluatePannel"
                    class="evaluate-pannel-close"
                    icon-class="closeBlack"
                  ></svg-icon>
                </div>
                <div class="evaluate-level clearfix">
                  <div @click="setEvaluateLevel('1')">
                    <div>
                      <svg-icon
                        v-if="evaluateLevel == '1'"
                        icon-class="evaluateWorseActive"
                        style="width: 30px;height: 30px;margin: 0;"
                      ></svg-icon>
                      <svg-icon
                        v-else
                        icon-class="evaluateWorse"
                        style="width: 30px;height: 30px;margin: 0;"
                      ></svg-icon>
                    </div>
                  </div>
                  <div @click="setEvaluateLevel('2')">
                    <div>
                      <svg-icon
                        v-if="evaluateLevel == '2'"
                        icon-class="evaluateLessActive"
                        style="width: 30px;height: 30px;margin: 0;"
                      ></svg-icon>
                      <svg-icon
                        v-else
                        icon-class="evaluateLess"
                        style="width: 30px;height: 30px;margin: 0;"
                      ></svg-icon>
                    </div>
                  </div>
                  <div @click="setEvaluateLevel('3')">
                    <div>
                      <svg-icon
                        v-if="evaluateLevel == '3'"
                        icon-class="evaluateNormalActive"
                        style="width: 30px;height: 30px;margin: 0;"
                      ></svg-icon>
                      <svg-icon
                        v-else
                        icon-class="evaluateNormal"
                        style="width: 30px;height: 30px;margin: 0;"
                      ></svg-icon>
                    </div>
                  </div>
                  <div @click="setEvaluateLevel('4')">
                    <div>
                      <svg-icon
                        v-if="evaluateLevel == '4'"
                        icon-class="evaluateSatisfiedActive"
                        style="width: 30px;height: 30px;margin: 0;"
                      ></svg-icon>
                      <svg-icon
                        v-else
                        icon-class="evaluateSatisfied"
                        style="width: 30px;height: 30px;margin: 0;"
                      ></svg-icon>
                    </div>
                  </div>
                  <div @click="setEvaluateLevel('5')">
                    <div>
                      <svg-icon
                        v-if="evaluateLevel == '5'"
                        icon-class="evaluateVeryActive"
                        style="width: 30px;height: 30px;margin: 0;"
                      ></svg-icon>
                      <svg-icon
                        v-else
                        icon-class="evaluateVery"
                        style="width: 30px;height: 30px;margin: 0;"
                      ></svg-icon>
                    </div>
                  </div>
                </div>
                <div class="evaluate-level-name">
                  <span class="very" v-if="evaluateLevel == 5">
                    <svg-icon icon-class="eval-very"></svg-icon>非常满意
                  </span>
                  <span class="satisfied" v-if="evaluateLevel == 4">
                    <svg-icon icon-class="eval-satisfied"></svg-icon>比较满意
                  </span>
                  <span class="normal" v-if="evaluateLevel == 3">
                    <svg-icon icon-class="eval-normal"></svg-icon>一般
                  </span>
                  <span class="less" v-if="evaluateLevel == 2">
                    <svg-icon icon-class="eval-less"></svg-icon>比较不满意
                  </span>
                  <span class="worse" v-if="evaluateLevel == 1">
                    <svg-icon icon-class="eval-worse"></svg-icon>非常不满意
                  </span>
                </div>
                <div
                  class="evaluate-quick-content clearfix"
                  :class="renderLevelClass(evaluateLevel)"
                >
                  <span
                    @click="chooseEval(item)"
                    v-for="(item, index) in evaluateItem"
                    :class="renderActiveClass(item)"
                    :key="index"
                  >{{item.evaluateTagName}}</span>
                  <span @click="toggleClick" :class="customEval ? 'tagActive' : ''">写评价</span>
                </div>
                <div class="evaluate-content-wrap" v-if="customEval">
                  <textarea
                    class="evaluate-content"
                    v-model="evaluateContent"
                    rows="2"
                    name
                    placeholder="请填写评价内容（选填）"
                    id
                  ></textarea>
                </div>
                <div class="evaluate-submit">
                  <span
                    :class="(evaluateLevel != '0' && !evaluateSubmitted) ? '' : 'btnDisabled'"
                    @click="sendEvaluate"
                  >提交评价</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 聊天结束 -->

          <!-- 留言开始 -->
          <div class="leave-msg-container" v-if="chatShow === 'leaveMsg'">
            <div class="leave-msg-main">
              <div
                class="leave-msg-tips"
                v-if="initialData.calling_config"
              >{{initialData.calling_config.message_tip}}</div>
              <div class="form-item">
                <p class="item-title">
                  <span>*</span>手机:
                </p>
                <input v-model="mobile" class="item-content" type="text" />
              </div>
              <div class="form-item">
                <p class="item-title">邮箱:</p>
                <input v-model="email" class="item-content" type="text" />
              </div>
              <div class="form-item">
                <p class="item-title">
                  <span>*</span>问题描述:
                </p>
                <textarea v-model="content" class="item-content problem-detail" type="text"></textarea>
              </div>
              <div class="leave-msg-submit">
                <span :class="leaveMsgSubmitted ? 'btnDisabled' : ''" @click="submitLeaveMsg">提交留言</span>
                <div>
                  <div
                    style="margin-top: 8px;padding: 5px 0;display: inline-block;font-size: 12px;color: #3396fa;cursor: pointer;"
                    @click="viewHistory"
                  >查看聊天记录</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 留言结束 -->

          <!-- 排队开始 -->
          <div class="lineup-container" v-if="chatShow === 'lineup'">
            <div class="lineup-main">
              <div class="lineup-tips">{{lineup.obj.remark}}</div>
              <div class="lineup-count">
                <div class="count-tips">当前您排在第</div>
                <div class="count-num">
                  {{lineup.obj.queue_up_num + 1}}
                  <span>位</span>
                </div>
              </div>
              <div class="lineup-operation">
                <div>如果等不及，可以选择</div>
                <div class="to-leave-msg-btn" @click="toLeaveMsg">给我们留言</div>
                <div>
                  <div
                    style="margin-top: 8px;padding: 5px 0;display: inline-block;font-size: 12px;color: #3396fa;cursor: pointer;"
                    @click="viewHistory"
                  >查看聊天记录</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 排队结束 -->
        </div>
        <div class="rightContaienr">
          <div class="swipeImageContainer">
            <el-carousel indicator-position="outside">
              <el-carousel-item v-for="(image, index) in swipeImages" :key="'img'+ index">
                <img @click="picJumpLink(image)" :src="image.adPicture" alt />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="toolBoxTitle">
            <span class="line"></span>
            <span class="text">自助工具</span>
            <span class="line"></span>
          </div>
          <div class="toolBox">
            <div
              class="toolItem"
              v-for="(item, i) in iconLinkList"
              :key="'tool' + i"
            >
              <a href="javascript:void(0);" v-if="item.link.length == 0">
                <div class="itemIcon">
                  <img :src="item.icon" />
                </div>
                <div class="itemName">{{item.iconDesc}}</div>
              </a>
              <a :href="item.link" target="_blank" v-else>
                <div class="itemIcon">
                  <img :src="item.icon" />
                </div>
                <div class="itemName">{{item.iconDesc}}</div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="tech-support" v-if="chatShow !== 'viewHis'">启博旗下微聊客服提供支持</div>
    </div>
    <audio id="music_src_message" :src="voiceSource" preload="preload"></audio>
  </div>
</template>

<script>
import VueEmoji from "@/libs/emoji/Emoji";
import emojiData from "@/libs/emoji/emoji-data";
import InitAvatar from "@/assets/images/avatar/client_avatar.png";
import voiceSource from "@/assets/voice/new-message.mp3";
import img from "@/assets/images/ad/banner1.png";
export default {
  name: "fullscreen",
  data() {
    return {
      addr: "",
      orderId: "",
      callingId: "",
      isPasteImge: false,
      addrList: [],
      showPopup: false,
      voiceSource: voiceSource,
      chatShow: "chat", // 默认显示会话界面
      voiceOn: true, // 默认开启声音通知
      serviceAvatar: InitAvatar, // 客服头像
      serviceName: "", // header文案，连接成功后 显示客服的昵称
      noServiceTips: "连接中，请稍后...", // header文案，未连接到客服时显示
      agent_sign: "",
      textarea: "", // 发送的消息内容
      showEmoji: false, // 显示表情面板
      messageHistory: false, // 是否显示加载更多
      isLoading: false, // 加载更多 -加载中
      showWechat: false, // 显示微信二维码
      WechatImage: "", // 微信二维码
      QQUrl: "", // QQ号
      showQQIcon: false, // QQ号图标默认不显示
      chatWithService: true, // 显示聊天输入框
      chatend: false, // 聊天结束
      isBlack: false, // 被加入黑名单
      sendActive: false, //  发送按钮可点击
      evaluateLevel: "5", // 评价等级
      evaluateContent: "", // 评价内容
      showEvaluatePannel: false, // 显示评价面板
      mobile: "", // 留言-手机号
      email: "", // 留言-邮箱
      content: "", // 留言-内容
      leaveMsgSubmitted: false, // 留言已提交
      evaluateSubmitted: false, // 评价已提交
      openWindowUrl: "", // 单独打开窗口连接
      alone: "", // 是否是单独的页面 ，1表示是单独的界面
      agentUid: "", // 客服id
      showSendGoods: true, // 发送商品样式，默认展示
      currentPage: 1, // 查询历史-分页
      pageSize: 10, // 查询历史-每页显示条数
      viewHisMessageId: "",
      showMore: false,
      stopVoice: false,
      evaluateItem: [],
      chooseEvaluate: [],
      quickEvaluate: {},
      customEval: false,
      uploadPrgressTimer: null,
      recallTipsShow: false,
      mobile: "",
      swipeImages: [],
      iconLinkList: [],
      chatType: ''
    };
  },
  filters: {
    formateDateTime: val => {
      let date = new Date(val * 1000); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h = date.getHours() + ":";
      let m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      // let s = date.getSeconds()
      return Y + M + D + h + m;
      // return Y + M + D + h + m + s
    }
  },
  components: {
    VueEmoji
  },
  computed: {
    websocket() {
      return this.$store.state.ws;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    messages() {
      return this.$store.state.messages;
    },
    sayMsg() {
      return this.$store.state.sayMsg;
    },
    chatClose() {
      return this.$store.state.chatClose;
    },
    inviteEvaluation() {
      return this.$store.state.inviteEvaluation;
    },
    blackClose() {
      return this.$store.state.blackClose;
    },
    leaveMsg() {
      return this.$store.state.leaveMsg;
    },
    autoTurnManual() {
      return this.$store.state.autoTurnManual;
    },
    lineup() {
      return this.$store.state.lineup;
    },
    switching() {
      return this.$store.state.switching;
    },
    login() {
      return this.$store.state.login;
    },
    initialData() {
      return this.$store.state.initialData;
    },
    isAiReply() {
      return this.$store.state.isAiReply;
    },
  },
  watch: {
    initialData: {
      handler(val) {
        if (val.calling_config.message_content_open === "1") {
          this.content = val.calling_config.message_content;
        }
      },
      deep: true
    },
    textarea: {
      handler(val) {
        this.msgForesee(val);
        if (this.textarea.trim().length > 0) {
          this.sendActive = true;
        } else {
          this.sendActive = false;
        }
      },
      deep: true
    },
    loginInfo: {
      handler(val) {
        if (val) {
          console.log('val=====', val)
          this.serviceAvatar = this.loginInfo.agent_avatar || InitAvatar;
          this.serviceName = this.loginInfo.agent_nickname;
          this.agent_sign = this.loginInfo.agent_sign;
          this.agentUid = this.loginInfo.agent_uid;
          this.getContactInfo(this.loginInfo.agent_uid);
          for (let uid in val.chats) {
            this.chatShow = "chat";
            this.messageHistory = val.chats[uid].messages_history;
            this.scrollToBottom();
          }
        }
      },
      deep: true
    },
    sayMsg: {
      handler(val) {
        this.audio();
        this.scrollToBottom();
      },
      deep: true
    },
    messages: {
      handler(val) {
        val.forEach(item => {
          if (item.sensitiveword) {
            this.msgForesee('');
          }
        })
      },
      deep: true
    },
    login: {
      handler(val) {
        console.log('val======', val)
        this.serviceAvatar = this.loginInfo.agent_avatar || InitAvatar;
        this.serviceName = this.loginInfo.agent_nickname;
        this.agent_sign = this.loginInfo.agent_sign;
        this.agentUid = this.loginInfo.agent_uid;
        this.scrollToBottom();
      },
      deep: true
    },
    switching: {
      handler(val) {
        this.serviceAvatar = val.agent_avatar || InitAvatar;
        this.serviceName = val.agent_name;
        this.agent_sign = val.agent_sign;
        this.agentUid = val.from_uid;
        // 刷新客服微信和qq联系方式
        this.getContactInfo(this.agentUid)
      },
      deep: true
    },
    autoTurnManual: {
      handler(val) {
        this.robotTurnManual();
      },
      deep: true
    },
    chatClose: {
      handler(val) {
        this.chatWithService = false;
        this.chatend = true;
        this.showEmoji = false;
        this.showWechat = false;
        this.showEvaluatePannel = true;
      },
      deep: true
    },
    inviteEvaluation: {
      handler(val) {
        if(!this.evaluateSubmitted){
          this.showEvaluatePannel = true;
        }
      },
      deep: true
    },
    blackClose: {
      handler(val) {
        this.chatWithService = false;
        this.chatend = false;
        this.isBlack = true;
        this.showEmoji = false;
        this.showWechat = false;
        this.showEvaluatePannel = false;
      },
      deep: true
    },
    leaveMsg: {
      handler(val) {
        this.noServiceTips = "给我们留言";
        this.serviceName = "";
        this.agent_sign = "";
        this.chatShow = "leaveMsg";
      },
      deep: true
    },
    lineup: {
      handler(val) {
        if (val && val.lineup) {
          this.chatShow = "lineup";
        }
      },
      deep: true
    }
  },
  created() {
    this.scrollToBottom();
    this.getQuickEvaluate();
    this.getAdd();
    this.getPageTitle();
  },
  mounted() {
    eventBus.$on("waitend", () => {
      this.chatShow = "chat";
    });
    let _this = this;
    this.$nextTick(function() {
      setTimeout(()=> {
        _this.getInitialData()
      })
    })
    document.addEventListener("click", function() {
      _this.showEmoji = false;
      _this.showWechat = false;
    });
    this.openWindowUrl = window.location.href + "&alone=1";
    let alone = this.$utils.GetQueryString("alone");
    this.chatType = this.$utils.GetQueryString("chatType");
    this.alone = alone;
    if (!alone) {
      sessionStorage.removeItem("wlNewWindow");
    }

    window.addEventListener(
      "message",
      function openNewWindow(e) {
        window.removeEventListener("message", openNewWindow, false);
       if (e.data === 'closeModel') {
         sessionStorage.removeItem("wlNewWindow")
         _this.chatEndHandler()
       }else {
         if (!sessionStorage.getItem("wlNewWindow")) {
           sessionStorage.setItem("wlNewWindow", true);
           _this.openWindow();
         }
       }


      },
      false
    );
    document.getElementById("chatMain").addEventListener(
      "click",
      function() {
        // 机器人常见问题选择
        document.querySelectorAll(".j-send-problem").forEach((item, i) => {
          item.onclick = function() {
            let newMessage = {
              type: "say",
              sendtime: "" + _this.$utils.getTimes(),
              from_uid: _this.loginInfo.client_uid,
              to_uid: _this.loginInfo.agent_uid,
              role: "client",
              msg_type: "text",
              text: this.innerText
            };
            if (_this.websocket.readyState === 1) {
              _this.renderMsg(newMessage);
            }
          };
        });
        // // 转人工
        if (document.querySelector(".js_manual")) {
          document.querySelector(".js_manual").onclick = function() {
            _this.robotTurnManual();
          };
        }

        // 去留言
        if (document.querySelector(".js_to_leaveMsg")) {
          document.querySelector(".js_to_leaveMsg").onclick = function() {
            _this.noServiceTips = "给我们留言";
            _this.serviceName = "";

            _this.agent_sign = "";
            _this.chatShow = "leaveMsg";
          };
        }
        // 已解决
        if (document.querySelector(".js_settled")) {
          document.querySelectorAll(".js_settled").forEach(function(item,index){
            item.onclick = function() {
              let vId = this.getAttribute("data-visitId");
              let callingId = this.getAttribute("data-callingId");
              _this.robotEvaluate(1, vId, callingId);
            };
          })
        }
        // 未解决
        if (document.querySelector(".js_no_settled")) {
          document.querySelectorAll(".js_no_settled").forEach(function(item,index){
            item.onclick = function() {
              let vId = this.getAttribute("data-visitId");
              let callingId = this.getAttribute("data-callingId");
              _this.robotEvaluate(0, vId, callingId);
            };
          })
        }
      },
      true
    );
  },
  updated(){
    let video = document.getElementsByClassName("videoId")
    if(video){
      // 隐藏video标签控制条右侧三个点
      for(let i = 0; i < video.length;i++){
            video[i]['disablePictureInPicture'] = true; //disablePictureInPicture的属性改为true
      }
    }
  },
  methods: {
    /**
     * 头部标题
     */
    getPageTitle() {
      this.$http.getPageTitleAPI({
        cid:Number(this.$utils.GetQueryString("cid"))
      }).then(res => {
        if(res.status==1){
          document.title = res.data || '微聊客服'
        }
      })
    },
    getAdd() {
      this.$http
        .getAddAPI({
          cid: this.$utils.GetQueryString("cid")
        })
        .then(res => {
          if (res.status == 1) {
            this.swipeImages = res.data.adPictures;
            this.iconLinkList = res.data.iconLink;
          }
          console.log("res==", res);
        });
    },
    /**
     * 获取评价快捷选择标签
     */
    getQuickEvaluate() {
      this.$http.getQuickEvaluateAPI({
        cid:this.$utils.GetQueryString("cid")
      }).then(res => {
        if (res.status == 1) {
          this.quickEvaluate = res.data;
          this.evaluateItem = res.data[this.evaluateLevel];
        }
      });
    },
    /**
     * 聊天内容滚动到底部
     * */
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.detailCont.scrollTop = this.$refs.detailCont.scrollHeight;
        setTimeout(() => {
          document.querySelector(".scrollBottom").scrollIntoView()
        },10)
      });
    },
    /**
     * 网页静音/非静音切换
     */
    voiceToggle() {
      console.log("this.stopVoice==", this.stopVoice);
      this.stopVoice = !this.stopVoice;
      this.voiceOn = !this.voiceOn;
    },
    //播放音乐
    audio() {
      if (this.stopVoice) {
        return false;
      }
      let audio = document.getElementById("music_src_message");
      audio.play();
    },
    /**
     * 访客结束对话
     */
    chatEndHandler() {
      if (this.websocket.readyState === 1) {
        this.websocket.send(JSON.stringify({ clientclose: {} }));
      }
      this.chatWithService = false;
      this.chatend = true;
      this.showEmoji = false;
      this.showWechat = false;
      this.showEvaluatePannel = true;
    },
    /**
     * 【发送表情】
     */
    // 点击显示/隐藏表情弹框
    showEmojiFn(event) {
      event.stopPropagation();
      this.showEmoji = !this.showEmoji;
    },
    // 选择表情
    selectEmoji(emoji) {
      // document.getElementById('chatTextDiv').focus()
      const newEmoji = "[" + emoji.value[0] + "]";
      this.showEmoji = false;
      this.sendBtn = false;
      this.textarea += newEmoji; // ':' + emoji.name + ':'
      // this.insertHtmlAtCaret(newEmoji)
    },
    /**
     * 发送图片
     */
    imageClick() {
      this.$refs.imgUpload.click();
    },
    uploadImage(e) {
      let img = e.target.files[0];
      let size = img.size;
      let name = img.name;
      // if (size > 5242880) {
      //   this.$toast.fail('对不起，请选择5M以内的图片！')
      //   return false
      // }
      let type = name.substring(name.lastIndexOf("."));
      let uploadFile = new File([img], new Date().getTime() + type, {
        size: size,
        type: img.type
      });
      let formdata = new FormData();
      formdata.set("file", uploadFile);
      this.sendImage(formdata);
    },
    sendImage(img) {
      this.$http.sendImageMsgAPI(img).then(res => {
        if (res.status === "1") {
          let newMessage = {
            type: "say",
            sendtime: "" + this.$utils.getTimes(),
            from_uid: this.loginInfo.client_uid,
            to_uid: this.agentUid,
            role: "client",
            msg_type: "image",
            text: res.data
          };
          if (this.websocket.readyState === 1) {
            this.renderMsg(newMessage);
          } else {
            this.$toast.fail("消息发送失败");
          }
        } else {
          this.$toast.fail(res.msg);
        }
        this.$refs.imgUpload.value = "";
      });
    },

    /**
     * 发送文件
     */
    fileClick() {
      this.$refs.fileUpload.click();
    },
    uploadFile(e) {
      let file = e.target.files[0];
      let size = file.size;
      let name = file.name;
      if (size > 1024 * 1024 * 10) {
        this.$toast.fail("对不起，请选择10M以内的文件！");
        return false;
      }
      let type = name.substring(name.lastIndexOf("."));
      let uploadFile = new File([file], name, {
        size: size,
        type: file.type
      });
      let formdata = new FormData();
      formdata.set("file", uploadFile);
      this.sendFile(formdata);
    },
    sendFile(file) {
      this.$http.sendFileMsgAPI(file).then(res => {
        if (res.status === "1") {
          let newMessage = {
            type: "say",
            sendtime: "" + this.$utils.getTimes(),
            from_uid: this.loginInfo.client_uid,
            to_uid: this.agentUid,
            role: "client",
            msg_type: "file",
            text: res.data.fileName + "," + res.data.fileUrl
          };
          if (this.websocket.readyState === 1) {
            this.renderMsg(newMessage);
          } else {
            this.$toast.fail("消息发送失败");
          }
        } else {
          this.$toast.fail(res.msg);
        }
        this.$refs.fileUpload.value = "";
      });
    },
    /**
     * 发送视频
     * */
    videoClick() {
      this.$refs.videoUpload.click();
    },

    clearUploadTimer() {
      this.$toast.clear();
      clearInterval(this.uploadPrgressTimer);
      this.$http.uploadProgressResetAPI();
    },
    uploadVideo(e) {
      let video = e.target.files[0];
      let size = video.size,
        type = video.type;
      if (type.indexOf("video") == -1) {
        this.$toast.fail("视频格式错误，请发送正确的视频文件！");
        return false;
      }
      if (size > 1024 * 1024 * 30) {
        this.$toast.fail("请选择30M以内的视频！");
        return false;
      }
      let formdata = new FormData();
      formdata.set("file", video);
      this.showMoreFn = false;
      this.uploadPrgressTimer = setInterval(() => {
        this.$http
          .uploadProgressAPI()
          .then(res => {
            this.$toast.loading({
              duration: 0, // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: "spinner",
              message: `发送中...${res}%`
            });
            if (res == 100) {
              this.clearUploadTimer();
            }
          })
          .catch(() => {
            clearInterval(this.uploadPrgressTimer);
          });
      }, 100);
      this.$http
        .sendVideoMsgAPI(formdata)
        .then(res => {
          this.clearUploadTimer();
          if (res.status == "success") {
            let newMessage = {
              type: "say",
              sendtime: "" + this.$utils.getTimes(),
              from_uid: this.loginInfo.client_uid,
              // 'showtime': this.$utils.isShowMsgTime(false, this.$utils.getTimes()),
              to_uid: this.agentUid,
              role: "client",
              msg_type: "video",
              text: res.data.videoUrl,
              reduced_graph: res.data.reducedImage,
              talk_time: res.data.time
            };
            if (this.websocket.readyState === 1) {
              this.renderMsg(newMessage);
            } else {
              this.$toast.fail("消息发送失败");
            }
          } else {
            this.$toast.fail(res.message);
          }
          this.$refs.videoUpload.value = "";
        })
        .catch(() => {
          this.clearUploadTimer();
        });
    },
    focusEvent() {
      let that = this;
      // document.querySelector('.chat-bottom').style.backgroundColor = '#fdfdfd'
      // document.querySelector('.recallInput').style.backgroundColor = '#fdfdfd'
      // document.querySelector('#chatTextarea').style.backgroundColor = '#fdfdfd'
      document.querySelector("#chatTextarea").addEventListener(
        "paste",
        function(e) {
          var cbd = e.clipboardData;
          var ua = window.navigator.userAgent;
          // 如果是 Safari 直接 return
          if (!(e.clipboardData && e.clipboardData.items)) {
            return;
          }
          // Mac平台下Chrome49版本以下 复制Finder中的文件的Bug Hack掉
          if (
            cbd.items &&
            cbd.items.length === 2 &&
            cbd.items[0].kind === "string" &&
            cbd.items[1].kind === "file" &&
            cbd.types &&
            cbd.types.length === 2 &&
            cbd.types[0] === "text/plain" &&
            cbd.types[1] === "Files" &&
            ua.match(/Macintosh/i) &&
            Number(ua.match(/Chrome\/(\d{2})/i)[1]) < 49
          ) {
            return;
          }
          for (var i = 0; i < cbd.items.length; i++) {
            var item = cbd.items[i]; // cbd.items[i]
            if (item.kind == "file") {
              var blob = item.getAsFile();
              if (blob.size === 0) {
                return;
              }
              if (!that.isPasteImge) {
                that.isPasteImge = true;
                // blob 就是从剪切板获得的文件 可以进行上传或其他操作
                /*-----------------------与后台进行交互 start-----------------------*/
                let formdata = new FormData();
                formdata.append("file", blob);
                that.$http
                  .sendImageMsgAPI(formdata)
                  .then(res => {
                    const resData = res;
                    setTimeout(() => {
                      that.isPasteImge = false;
                    }, 100);
                    if (resData.status == 1) {
                      // var img = document.createElement("img");
                      // img.src = resData.data;
                      // img.setAttribute('preview', '1') // 图片预览
                      // document.getElementById('chatTextDiv').appendChild(img);
                      // that.keepInLast()
                      let newMessage = {
                        type: "say",
                        sendtime: "" + that.$utils.getTimes(),
                        from_uid: that.loginInfo.client_uid,
                        to_uid: that.agentUid,
                        role: "client",
                        msg_type: "image",
                        text: resData.data
                      };
                      if (that.websocket.readyState === 1) {
                        that.renderMsg(newMessage);
                      } else {
                        that.$toast.fail("消息发送失败");
                      }
                    } else {
                      that.$toast.fail(resData.msg);
                    }
                  })
                  .catch(error => {
                    setTimeout(() => {
                      that.isPasteImge = false;
                    }, 100);
                    that.$toast.fail("图片发送失败，请重试！");
                  });
              }
            }
          }
        },
        false
      );
    },
    blurEvent(){
      // document.querySelector('.chat-bottom').style.backgroundColor = '#f5f6f7'
      // document.querySelector('.recallInput').style.backgroundColor = '#f5f6f7'
      // document.querySelector('#chatTextarea').style.backgroundColor = '#f5f6f7'
    },
    // 发送文本消息
    sendMsg(msg) {
      if (this.textarea.trim().length === 0) {
        this.$toast.fail("消息内容不能为空");
        return false;
      }
      let _this = this;
      var partten = /\[(.+?)\]/g;
      if (this.textarea.match(partten)) {
        this.textarea.match(partten).forEach(function(item) {
          for (let key in emojiData) {
            var emojiCN = "[" + emojiData[key][0] + "]";
            var emojiEN = ":" + key + ":";
            var reg = new RegExp("\\[(" + emojiData[key][0] + ")\\]", "ig");
            if (item === emojiCN) {
              _this.textarea = _this.textarea.replace(
                new RegExp(reg, "g"),
                emojiEN
              );
            }
          }
        });
      }

      let newMessage = {
        type: "say",
        sendtime: "" + this.$utils.getTimes(),
        from_uid: this.loginInfo.client_uid,
        to_uid: this.agentUid,
        role: "client",
        msg_type: "text",
        text: this.textarea
      };
      if (this.websocket.readyState === 1) {
        this.renderMsg(newMessage);
        this.sendActive = false;
        this.$nextTick(() => {
          this.textarea = "";
        });
      } else {
        this.$toast.fail("消息发送失败");
      }
    },
    enterSendMsg(e) {
      // ctrl+enter同时按下时keycode为10
      if ((e.keyCode === 13 || e.keyCode === 10) && e.ctrlKey) {
        this.textarea += "\n";
        console.log(this.textarea)
      } else if (e.keyCode === 13) {
        e.preventDefault();
        this.sendMsg();
      }
    },
    // 发送成功后渲染消息
    renderMsg(msg) {
      this.websocket.send(JSON.stringify({ say: { message: msg } }));
      window.vm.$store.dispatch("_updateMsg", msg);
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    /**
     * 提交手机号
     */
    subitPhone() {
      let phoneReg = /(1[3|4|5|7|8|9][\d]{9}|0[\d]{2,3}-[\d]{7,8}|400[-]?[\d]{3}[-]?[\d]{4})/g
      if(!phoneReg.test(this.mobile)){
        this.$toast.fail("请填写正确的联系方式");
        return false;
      }
      this.$http
        .submitPhoneAPI({
          cid: Number(this.$utils.GetQueryString("cid")),
          visitorId: this.$store.state.loginInfo.client_uid,
          mobile: this.mobile
        })
        .then(res => {
          if(res.status==1){
            this.$toast.success("提交成功，我们将尽快与您取得联系！");
            let text = `<div><p><span style="color:rgb(70,172,200)">电话回拨</span></p><p>请求电话回拨，输入的电话号码是:<span style="color:rgb(194,79,74)">${this.mobile}</span></p></div>`
            let newMessage = {
              type: "say",
              sendtime: "" + this.$utils.getTimes(),
              from_uid: this.loginInfo.client_uid,
              to_uid: this.agentUid,
              role: "client",
              msg_type: "text",
              text: text
            };
            this.renderMsg(newMessage)
            this.mobile = "";
          }else{
            this.$toast.fail(res.msg);
          }
        })
        .catch(err => {
          this.mobile = "";
          this.$toast.fail("提交失败，我请重试！");
        });
    },
    /**
     * 获取联系客服-QQ 、微信信息
     */
    getContactInfo(csid) {
      let postData = {
        cid: this.$utils.GetQueryString("cid")
      }
      csid ? postData.csid = csid : ''
      this.$http
        .getContactInfoAPI(postData)
        .then(res => {
          if (res.status === "1") {
            if (res.data.set_qq_number) {
              this.showQQIcon = true;
              this.QQUrl = `tencent://message/?uin=${res.data.set_qq_number}&Site=&Menu=yes`;
            } else {
              this.showQQIcon = false;
            }
            this.WechatImage = res.data.set_wx_qrcode_url;
          }
        });
    },
    /**
     * 查看更多历史消息
     * */
    loadHistory() {
      let postParam = {
        currentPage: this.currentPage, // 当前页
        pageSize: this.pageSize, // 每页行数
        companyId: this.$utils.GetQueryString("cid"), //  企业id
        agentUid: this.loginInfo.agent_uid, //  企业所属代理商id（0 代表启博 >0代表代理商）
        visitorId: this.loginInfo.client_uid, //  访客Id
        messagesId: this.loginInfo.chats[this.loginInfo.client_uid].messages_id,
        endTime: ""
      };
      this.isLoading = true;
      this.$http.getHistoryAPI(postParam).then(res => {
        this.isLoading = false;
        if (res.status === "1") {
          let oldHeight = this.$refs.detailCont.scrollHeight;
          res.data.reverse().map(item => {
            this.$store.dispatch("_loadHistoryMsg", item);
          });
          this.$nextTick(() => {
            this.$refs.detailCont.scrollTop =
              this.$refs.detailCont.scrollHeight - oldHeight;
          });
          if (res.data.length < this.pageSize) {
            this.messageHistory = false;
          } else {
            this.currentPage = this.currentPage + 1;
          }
        }
      });
    },
    whiteIconClass(type) {
      switch (type) {
        case "image":
        case "goods":
        case "video":
          return "whiteIconClass";
        default:
          return "";
      }
    },
    // 消息预知
    msgForesee(msg) {
      if (this.initialData.is_foresee && msg.trim().length > 0) {
        let foreseeMsg = {
          type: "foresee",
          sendtime: "" + this.$utils.getTimes(),
          from_uid: this.loginInfo.client_uid,
          to_uid: this.agentUid,
          role: "client",
          msg_type: "foresee",
          text: msg
        };

        // if (msg.trim().length === 0) {
        //   this.$nextTick(() => {
        //     this.nullForesee = false;
        //   });
        // } else {
        //   this.nullForesee = true;
        // }
        if (this.nullForesee) {
          this.websocket.send(
            JSON.stringify({ foresee: { message: foreseeMsg } })
          );
        }
      }
    },
    /**
     * 【显示表情】
     */
    formatTrendEmoji(val) {
      let sName = val;
      let sImg = [];
      let rules = /:([^:][a-z_\-]+):/g;
      if (sName) {
        sName.replace(rules, function($1, $2) {
          sImg.push($2);
        });
        for (let i = 0; i < sImg.length; i++) {
          let str = "";
          let rStr = ":" + sImg[i] + ":";
          for (let key in emojiData) {
            if (sImg[i] === key) {
              let imgPath = require(`@/libs/emoji/images/${sImg[i]}.gif`);
              str = sName.replace(
                rStr,
                `<img style="display: inline-block;max-width: 24px;max-height: 24px;" src="` +
                  imgPath +
                  `" class="img">`
              );
            } else {
              str = sName.replace(rStr, rStr);
            }
            sName = str;
          }
        }
      }
      return sName;
    },
    /**
     * 阻止默认事件
     */
    stopPropagationFn(event) {
      event.stopPropagation();
    },
    /**
     * 展示微信二维码
     */
    showWechatFn(event) {
      event.stopPropagation();
      this.showWechat = !this.showWechat;
    },
    /**
     * 播放语音
     * @param event
     */
    voicePlay(e) {
      let _this = this;
      let event = e.currentTarget;
      let symbolVoice = event.getElementsByClassName("wifi-symbol")[0];
      let audioId = event.getElementsByClassName("audioId")[0];
      let parentBox = event.parentNode;

      if (this.$utils.hasClass(parentBox, "voicing")) {
        this.$utils.removeClass(parentBox, "voicing");
        audioId.pause(); // 暂停-从头播放
        audioId.currentTime = 0;
        this.$utils.removeClass(symbolVoice, "bofang");
      } else {
        document.querySelectorAll(".bubble").forEach(function(item, i) {
          _this.$utils.removeClass(item, "voicing");
        });
        document.querySelectorAll(".wifi-symbol").forEach(function(item, i) {
          _this.$utils.removeClass(item, "bofang");
        });
        document
          .querySelectorAll("audio")
          .forEach(function(audioItem, audioIndex) {
            audioItem.pause();
            audioItem.currentTime = 0;
          });

        this.$utils.addClass(parentBox, "voicing");
        if (this.$utils.hasClass(symbolVoice, "bofang")) {
          audioId.pause(); // 暂停-从头播放
          audioId.currentTime = 0;
          this.$utils.removeClass(symbolVoice, "bofang");
        } else {
          audioId.play();
          this.$utils.addClass(symbolVoice, "bofang");
        }
      }
      // 播放完后执行
      audioId.addEventListener(
        "ended",
        function() {
          _this.$utils.removeClass(symbolVoice, "bofang");
        },
        false
      );
    },
    /**
     * 视频暂停
     * @param e
     */
    videoStop(e) {
      let _event = e.currentTarget;
      let _this = this;
      let videoId = _event.parentNode.getElementsByClassName("videoId")[0];
      let parentBox = _event.parentNode.parentNode;
      _this.$utils.removeClass(parentBox, "playing");
      // videoId.pause();
      document.querySelectorAll(".video-mask").forEach(function(item, i) {
        item.style.display = "block";
      });
      videoId.currentTime = 0;
    },
    /**
     * 视频播放
     * @param e
     */
    videoPlay(e) {
      let _this = this;
      var _event = e.currentTarget;
      var videoId = _event.parentNode.parentNode.getElementsByClassName(
        "videoId"
      )[0];
      var parentBox = _event.parentNode.parentNode.parentNode;
      // videoId.play()
      if (_this.$utils.hasClass(parentBox, "playing")) {
        _this.$utils.removeClass(parentBox, "playing");
        videoId.pause(); // 暂停-从头播放
        videoId.currentTime = 0;
        _event.parentNode.style.display = "block";
      } else {
        document.querySelectorAll(".video-mask").forEach(function(item, i) {
          item.style.display = "block";
        });
        document.querySelectorAll(".chat-content").forEach(function(item, i) {
          _this.$utils.removeClass(item, "playing");
        });
        document
          .querySelectorAll("video")
          .forEach(function(videoItem, videoIndex) {
            videoItem.pause();
            _event.parentNode.style.display = "block";
            videoItem.currentTime = 0;
          });
        _this.$utils.addClass(parentBox, "playing");
        _event.parentNode.style.display = "none";
        videoId.play();
      }
      // 播放完后执行
      videoId.addEventListener(
        "ended",
        function() {
          _this.$utils.removeClass(parentBox, "playing");
          videoId.currentTime = 0;
          document.querySelectorAll(".video-mask").forEach(function(item, i) {
            item.style.display = "block";
          });
        },
        false
      );
    },

    /**
     * 去留言
     */
    toLeaveMsg() {
      this.noServiceTips = "给我们留言";
      this.serviceName = "";

      this.agent_sign = "";
      this.chatShow = "leaveMsg";
    },
    /**
     *继续会话
     */
    chatReload() {
      window.location.reload();
    },
    /**
     * 满意度
     */
    toEvaluate() {
      this.showEvaluatePannel = true;
    },
    // 提交评价
    sendEvaluate() {
      if (this.evaluateLevel === "0") {
        this.$toast.fail("请先选择评价等级");
        return false;
      }
      if (!this.customEval) {
        this.evaluateContent = "";
      }
      let tagIds = [];
      this.chooseEvaluate.map(item => {
        tagIds.push(item.id);
      });
      let postData = {
        visitorId: this.loginInfo.client_uid,
        servicerId: this.loginInfo.agent_uid,
        grade: Number(this.evaluateLevel),
        content: this.evaluateContent,
        tagIds: tagIds,
        cid: this.$utils.GetQueryString("cid"),
        csid: ""
      };
      if (!this.evaluateSubmitted) {
        this.$http.chatEvaluateAPI(postData).then(res => {
          if (res.status === "1") {
            this.evaluateSubmitted = true;
            this.showEvaluatePannel = false;
            this.$toast.success(res.msg);
          } else {
            this.$toast.fail(res.msg);
          }
        });
      }
    },
    setEvaluateLevel(val) {
      this.evaluateLevel = val;
      this.chooseEvaluate = [];
      this.evaluateItem = this.quickEvaluate[val];
    },
    robotEvaluate(type, vId, callingId) {
      this.$http
        .robotEvaluateAPI({
          type: type,
          visitorId: vId
        })
        .then(res => {
          if (res.status == 1) {
            this.messages.map(item => {
              if (item.callingId == callingId) {
                if (type == 1) {
                  item.handler = "已解决";
                } else {
                  item.handler = "未解决";
                }
              }
            });
          }
        });
    },
    renderLevelClass(val) {
      switch (val) {
        case "1":
        case 1:
          return "wrapWorse";
        case "2":
        case 2:
          return "wrapLess";
        case "3":
        case 3:
          return "wrapNormal";
        case "4":
        case 4:
          return "wrapSatisfied";
        case "5":
        case 5:
          return "wrapVery";
      }
    },
    renderActiveClass(item) {
      if (this.chooseEvaluate.indexOf(item) > -1) {
        return "tagActive";
      }
    },
    toggleClick() {
      this.customEval = !this.customEval;
    },
    chooseEval(item) {
      if (this.chooseEvaluate.indexOf(item) > -1) {
        this.chooseEvaluate.splice(this.chooseEvaluate.indexOf(item), 1);
      } else {
        this.chooseEvaluate.push(item);
      }
    },
    closeEvaluatePannel() {
      this.showEvaluatePannel = false;
    },
    // 提交-留言
    submitLeaveMsg() {
      if (!this.leaveMsgSubmitted) {
        if (this.mobile.trim().length === 0) {
          this.$toast.fail("手机号不能为空");
          return false;
        }
        if (this.content.trim().length === 0) {
          this.$toast.fail("内容不能为空");
          return false;
        }
        let postData = {
          visitorId: this.loginInfo.client_uid,
          mobile: this.mobile,
          content: this.content,
          email: this.email,
          cid: this.$utils.GetQueryString("cid"),
          csid: ""
        };
        this.$http.chatLeaveMsgAPI(postData).then(res => {
          if (res.status === "1") {
            this.leaveMsgSubmitted = true;
          }
          this.$toast.fail(res.msg);
        });
      }
    },
    // 留言-查看历史消息
    viewHistory() {
      this.$store.dispatch("_clearMsg");
      sessionStorage.setItem("chatShow", this.chatShow);
      this.$http
        .viewHisChatDataAPI({
          cid: this.$utils.GetQueryString("cid"),
          visitorId: this.loginInfo.client_uid
        })
        .then(res => {
          let loginChats = res.data;
          let messageArr = [];
          for (let uid in loginChats.chats) {
            this.noServiceTips = "查看聊天记录";
            this.serviceName = "";
            this.agent_sign = "";
            messageArr = loginChats.chats[uid].messages;
            this.currentPage = 1;
            this.pageSize = 10;
            this.messageHistory = loginChats.chats[uid].messages_history;
            this.viewHisMessageId = loginChats.chats[uid].messages_id;
          }
          if (messageArr.length > 0) {
            messageArr.map(item => {
              this.$store.dispatch("_updateMsg", item);
            });
          } else {
            this.$toast.fail("暂无聊天记录");
            return false;
          }
          this.chatShow = "viewHis";
        });
    },
    picJumpLink(item) {
      if (item.link.length === 0) {
        return false;
      }
      window.open(item.link, "_blank");
    },
    // 机器人转人工
    robotTurnManual() {
      let params = {
        cid: this.$cookie.get("cid"),
        uniquecode: this.$cookie.get("FENBOT_fingerprint"),
        choose: "human",
        toid: this.$utils.GetQueryString("toid"),
        csid: this.$utils.GetQueryString("csid"),
        uid: this.$utils.GetQueryString("uid"),
        type: this.$utils.GetQueryString("type"),
        source: this.$utils.GetQueryString("source")
      };
      this.$store.dispatch("_login", params, this.loginInfo.agent_uid);
    },
    getInitialData:function(){
      this.$http.getInitialDataAPI({
        cid:Number(this.$utils.GetQueryString("cid"))
      }).then(res => {
        console.log(res)
        if(res.status==1){
          document.getElementsByClassName("headContainer")[0].style.backgroundColor = res.data.calling_config.dialog_box_color
        }
      })
    },
    // ai客服转人工
    transferToHuman() {
      this.$http.transferToHumanAPI({
        callingNo: true
      })
    }
  }
};
</script>

<style lang="scss">
//播放按钮
// video::-webkit-media-controls-play-button {
//   display: none;
// }
//进度条
video::-webkit-media-controls-timeline {
    display: none;
}
//观看的当前时间
video::-webkit-media-controls-current-time-display{
    display: none;
}
//剩余时间
video::-webkit-media-controls-time-remaining-display {
    display: none;
}
//音量按钮
video::-webkit-media-controls-mute-button {
    display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
    display: none;
}
//音量的控制条
video::-webkit-media-controls-volume-slider {
    display: none;
}
.fullscreen {
  $mainHeight: 100%;
  $mainPadding: 20px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // background: linear-gradient(#bccddf, #9495b4);
  position: relative;

  .chatContainer {
    width: 980px;
    min-width: 640px;
    height: 650px;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    overflow: hidden;
    display: flex;
    flex-direction: column;box-shadow: 0px 4px 36px 0px #00000026;
    border-radius: 16px;

    .headContainer {
      height: 60px;
      background: #428efe;
      font-size: 12px;
      color: #fff;
      display: flex;
      padding: 0 15px;
      box-sizing: border-box;
      align-items: center;

      .serviceInfoWrapper {
        display: flex;
        flex: 1;
        align-items: center;
        max-width: 70%;

        .serviceAvatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 15px;
          img {
            display: inline-block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .serviceInfo {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          & > div {
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .bigTitle {
            font-size: 16px;
          }
          .smallTitle {
            padding-top: 3px;
            box-sizing: border-box;
          }
        }
      }

      .handlerWrapper {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        .handlerItem {
          cursor: pointer;
        }
      }
    }

    .bottomContainer {
      flex: 1;
      display: flex;
      overflow: hidden;

      .leftContainer {
        flex: 1;
        background: #eef1f3;

        .chat-container {
          height: $mainHeight;
          position: relative;
          display: flex;
          flex-direction: column;

          .chat-main {
            background-color: #eef1f3;
            padding: 10px $mainPadding $mainPadding;
            box-sizing: border-box;
            overflow-y: auto;

            .load-history {
              text-align: center;
              margin-bottom: 5px;

              span {
                font-size: 12px;
                color: #a5a5a5;
                cursor: pointer;
              }
            }

            .message-container {
              font-size: 13px;

              .msg-times {
                text-align: center;
                margin-top: 20px;

                span {
                  display: inline-block;
                  /*background-color: #fff;*/
                  font-size: 12px;
                  border-radius: 5px;
                  padding: 6px;
                  color: #666;
                }
              }

              .msg-item {
                width: 100%;
                margin-top: 20px;

                .chat-avatar {
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                  overflow: hidden;
                  margin-right: 10px;
                  text-align: center;
                  line-height: 40px;
                  float: left;
                }

                .chat-content {
                  float: left;
                  /*max-width: calc(100% - 100px);*/
                  max-width: 600px;
                  line-height: 18px;
                  position: relative;

                  a {
                    color: #3396fa !important;
                    cursor: pointer;
                  }

                  img {
                    max-width: 100%;
                    height: auto;
                  }

                  .msg-time {
                    font-size: 12px;
                    padding-bottom: 2px;
                    color: #666;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }

                  .msg-content {
                    display: inline-block;
                    padding: 6px;
                    border-radius: 6px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    overflow: hidden;
                    font-size: 14px;
                    line-height: 22px;
                    padding: 15px;
                    /* margin: 10px; */
                    max-width: 100%;
                    word-break: break-word;
                    white-space: pre-wrap;
                    overflow: hidden;

                    .problem-item {
                      color: #488bff;
                      padding: 5px;
                      cursor: pointer;
                    }

                    .manual {
                      color: #488bff;
                      cursor: pointer;
                    }

                    .textMsg,
                    &.textMsg,
                    .fileMsg,
                    &.fileMsg {
                      /*padding: 10px;*/
                    }

                    &.imgMsg,
                    .imgMsg {
                      font-size: 0;
                      line-height: 0;

                      img {
                        max-width: 100%;
                        height: auto;
                      }
                    }

                    &.voiceMsg,
                    .voiceMsg {
                      line-height: 30px;
                      cursor: pointer;

                      .wifi-symbol {
                        width: 30px;
                        height: 30px;
                        box-sizing: border-box;
                        overflow: hidden;

                        &.voice-agent {
                          float: left;
                          transform: rotate(0deg) scale(0.6);
                        }

                        &.voice-client {
                          float: right;
                          transform: rotate(180deg) scale(0.6);
                        }

                        &.bofang {
                          .second {
                            animation: bofang 1.3s infinite 0.2s;
                          }

                          .third {
                            animation: bofang 1.3s infinite 0.35s;
                          }
                        }
                      }

                      .wifi-circle {
                        width: 30px;
                        height: 30px;
                        position: absolute;
                      }

                      .first {
                        background: url("../../assets/images/voice/1.png")
                          no-repeat center center;
                      }

                      .second {
                        background: url("../../assets/images/voice/2.png")
                          no-repeat center center;
                      }

                      .third {
                        background: url("../../assets/images/voice/3.png")
                          no-repeat center center;
                      }

                      @-webkit-keyframes bofang {
                        0% {
                          opacity: 0; /*初始状态 透明度为0*/
                        }
                        100% {
                          opacity: 1; /*结尾状态 透明度为1*/
                        }
                      }
                      @-moz-keyframes bofang {
                        0% {
                          opacity: 0; /*初始状态 透明度为0*/
                        }
                        100% {
                          opacity: 1; /*结尾状态 透明度为1*/
                        }
                      }

                      @keyframes bofang {
                        0% {
                          opacity: 0; /*初始状态 透明度为0*/
                        }
                        100% {
                          opacity: 1; /*结尾状态 透明度为1*/
                        }
                      }
                    }

                    &.videoMsg,
                    .videoMsg {
                      position: relative;
                      max-width: 100%;

                      video {
                        max-width: 100%;
                        display: block;
                      }

                      .video-mask {
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                        background-color: rgba(0, 0, 0, 0.5);

                        .playBtn {
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          width: 30%;
                          height: 30%;
                          transform: translate(-50%, -50%);
                          cursor: pointer;
                        }
                      }
                    }

                    &.fileMsg,
                    .fileMsg {
                      color: #666;
                      font-size: 12px;

                      .view-file {
                        color: #3396fb;
                        margin-left: 5px;
                        cursor: pointer;
                      }
                    }

                    &.goodMsg,
                    .goodMsg {
                      padding: 0;
                      /*border: none;*/
                      background-color: #fff;
                      cursor: pointer;

                      .send-goods-box {
                        max-width: 320px;
                        margin: 0 auto;
                        background-color: #fff;
                        border-radius: 8px;
                        box-shadow: 0px 4px 21px 0px rgba(0, 0, 0, 0.07);
                        padding: 8px;
                        box-sizing: border-box;

                        .send-goods-info-box {
                          display: block;
                        }

                        .send-goods-image {
                          width: 60px;
                          height: 60px;
                          border-radius: 5px;
                          margin-right: 10px;
                          overflow: hidden;

                          img {
                            display: inline-block;
                            width: 100%;
                            height: 100%;
                            border-radius: 5px;
                          }
                        }

                        .send-goods-info {
                          max-width: 230px;
                          font-size: 13px;

                          .send-goods-title {
                            line-height: 18px;
                            margin-bottom: 10px;
                            color: #333;
                          }

                          .send-goods-price {
                            color: #ff070f;

                            span {
                              padding-left: 3px;
                            }
                          }
                        }
                      }
                    }

                    &.couponMsg,
                    .couponMsg {
                      .coupon-container {
                        display: block;
                        color: #333;
                        font-size: 12px;

                        .coupon-image {
                          width: 80px;
                          height: 74px;
                          overflow: hidden;
                          margin-right: 10px;

                          img {
                            display: inline-block;
                            width: 100%;
                            height: 100%;
                          }
                        }

                        .coupon-content {
                          max-width: calc(100% - 90px);

                          .coupon-title {
                            font-weight: bold;
                            font-size: 13px;
                            min-height: 36px;
                          }

                          .coupon-desc {
                            color: #999;
                            padding-top: 0px;
                            box-sizing: border-box;
                          }

                          .coupon-price {
                            padding-top: 0px;
                            color: #f4403d;
                            box-sizing: border-box;
                          }
                        }
                      }
                    }

                    &.expressMsg,
                    .expressMsg {
                      .express-container {
                        .order-no-type {
                          .order-no {
                            font-size: 12px;
                            color: #666666;
                            line-height: 26px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            max-width: calc(100% - 120px);
                          }

                          .order-type {
                            span {
                              display: inline-block;
                              border: 1px solid #666;
                              border-radius: 10px;
                              padding: 3px 8px;
                              color: #666;
                            }

                            &.order-status1,
                            &.order-statu0,
                            &.order-status2 {
                              span {
                                color: #f4403d;
                                border-color: #f4403d;
                              }
                            }
                          }
                        }

                        .order-container {
                          margin-top: 10px;
                          display: block;
                          color: #333;

                          .order-goods-image {
                            width: 80px;
                            height: 74px;
                            overflow: hidden;
                            margin-right: 10px;

                            img {
                              display: inline-block;
                              width: 100%;
                              height: 100%;
                            }
                          }

                          .order-goods-info {
                            max-width: calc(100% - 90px);

                            .order-goods-title {
                              font-weight: bold;
                              font-size: 13px;
                              min-height: 54px;
                            }

                            .order-goods-price {
                              padding-top: 0px;
                              color: #f4403d;
                              box-sizing: border-box;
                            }
                          }
                        }
                      }
                    }

                    &.orderInfoMsg,
                    .orderInfoMsg {
                      /*width: 320px;*/
                      padding: 10px;

                      .order-msg-title {
                        font-size: 14px;
                        color: #333;
                        font-weight: bold;
                      }

                      .order-msg-goods-container {
                        background: rgba(249, 249, 249, 1);
                        border-radius: 10px;
                        overflow: hidden;
                        margin-top: 12px;

                        .order-goods-img,
                        .order-goods-detail {
                          float: left;
                        }

                        .order-goods-img {
                          width: 55px;
                          height: 55px;
                          overflow: hidden;
                          margin-right: 12.5px;

                          img {
                            display: block;
                            width: 100%;
                            height: 100%;
                          }
                        }

                        .order-goods-detail {
                          height: 55px;
                          line-height: 27.5px;
                          font-size: 12px;
                          width: calc(100% - 74px);

                          .order-goods-name {
                            color: #333;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          }

                          .order-goods-count {
                            color: #999999;
                            font-size: 11px;
                          }
                        }
                      }

                      .order-msg-addr {
                        color: #666;
                        font-size: 12px;

                        .addr-item {
                          margin: 11px 0;
                        }

                        .label-name,
                        .label-content {
                          float: left;
                        }

                        .label-name {
                          width: 40px;
                        }

                        .label-content {
                          width: calc(100% - 40px);
                        }
                      }

                      .order-msg-operate {
                        text-align: center;
                        margin-top: 17px;

                        & > div + div {
                          margin-left: 10px;
                        }

                        & > div {
                          float: left;

                          span,
                          a {
                            display: inline-block;
                            border: 1px solid #d6d6d6;
                            border-radius: 12px;
                            padding: 6px 12px;
                            box-sizing: border-box;
                            font-size: 12px;
                            cursor: pointer;
                            white-space: nowrap;
                            color: #666;

                            &.toHuman {
                              background: linear-gradient(
                                -90deg,
                                rgba(0, 191, 226, 1),
                                rgba(66, 142, 254, 1)
                              );
                              color: #fff;
                              border: none;
                            }
                          }
                        }
                      }
                    }

                    &.deliveryMsg,
                    .deliveryMsg,
                    &.refundMsg,
                    .refundMsg,
                    &.arrivalMsg,
                    .arrivalMsg,
                    &.placeOrderMsg,
                    .placeOrderMsg {
                      padding: 8px;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;

                      .orderTitle {
                        font-size: 13px;
                        font-weight: bold;
                        color: #333;
                      }

                      .orderGood-container {
                        display: flex;
                        margin: 8px 0;
                        background-color: #fafafa;
                        border-radius: 3px;
                        overflow: hidden;
                        cursor: pointer;

                        .goods-image {
                          width: 40px;
                          height: 40px;

                          img {
                            width: 100%;
                            height: 100%;
                          }
                        }

                        .goods-detail {
                          flex: 1;
                          overflow: hidden;
                          padding: 0 6px;
                          box-sizing: border-box;

                          .goods-order-title {
                            font-size: 13px;
                            color: #333;
                            width: 100%;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            line-height: 25px;
                          }

                          .goods-order-detail {
                            font-size: 10px;
                            color: #666;
                          }
                        }
                      }

                      .operation-btn {
                        text-align: right;
                        padding-top: 8px;

                        .editBtn,
                        .confirmBtn {
                          display: inline-block;
                          font-size: 13px;
                          padding: 6px 10px;
                          border-radius: 6px;
                          cursor: pointer;
                          margin-top: 5px;
                        }

                        .editBtn {
                          color: #999;
                          border: 1px solid #999;
                          border-radius: 6px;
                          margin-right: 8px;
                        }

                        .confirmBtn {
                          background-color: #3396fb;
                          color: #fff !important;
                        }

                        a {
                          background-color: #3396fb;
                          color: #fff !important;
                          font-size: 13px;
                          padding: 6px 10px;
                          border-radius: 6px;
                          cursor: pointer;
                        }
                      }
                    }

                    &.deliveryMsg,
                    .deliveryMsg {
                      .van-icon-arrow-down {
                        cursor: pointer;
                      }

                      .deliveryInfo {
                        font-size: 12px;

                        .deliveryInfo-item {
                          display: flex;

                          .deliveryInfo-label {
                            width: 60px;
                          }

                          .deliveryInfo-detail {
                            flex: 1;
                          }
                        }
                      }
                    }

                    &.placeOrderMsg,
                    .placeOrderMsg {
                      .addressInfo {
                        display: flex;
                        font-size: 12px;

                        .label {
                          width: 40px;
                        }

                        .detail {
                          flex: 1;
                        }
                      }
                    }

                    &.refundMsg,
                    .refundMsg {
                      .order-msg-no {
                        padding-top: 6px;
                      }
                      .refundInfo {
                        font-size: 13px;
                        color: #333;
                      }
                    }
                  }
                }
              }

              .event-msg {
                text-align: center;
                line-height: 14px;
                color: #babcbb;
              }

              .client-msg {
                .chat-avatar {
                  float: right;
                  margin: 0 0 0 10px;
                  background-color: #3396fa;
                  color: #fff;
                }

                .chat-content {
                  float: right;

                  &:before {
                    position: absolute;
                    top: 4px;
                    right: -6px;
                    content: "";
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-bottom: 6px solid transparent;
                    border-left: 6px solid #c8e6ff;
                  }

                  &:after {
                    position: absolute;
                    top: 4px;
                    right: -5px;
                    content: "";
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-bottom: 6px solid transparent;
                    border-left: 6px solid #c8e6ff;
                  }

                  .msg-content {
                    float: right;
                    background-color: #c8e6ff;
                    border: 1px solid #c8e6ff;
                  }

                  .msg-time {
                    text-align: right;
                  }

                  &.whiteIconClass {
                    .msg-content {
                      background-color: #fff;
                      border: 1px solid #fff;
                      padding: 0;
                    }

                    &:before {
                      border-left: 6px solid #ededed;
                    }

                    &:after {
                      border-left: 6px solid #fff;
                    }
                  }
                }
              }

              .agent-msg {
                .chat-content {
                  &:before {
                    position: absolute;
                    top: 24px;
                    left: -6px;
                    content: "";
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-bottom: 6px solid transparent;
                    border-right: 6px solid #ededed;
                  }

                  &:after {
                    position: absolute;
                    top: 24px;
                    left: -5px;
                    content: "";
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-bottom: 6px solid transparent;
                    border-right: 6px solid #fff;
                  }

                  .msg-content {
                    background-color: #fff;
                    border: 1px solid #ededed;
                    .textMsg {
                      li {
                        margin-left: 15px;
                      }
                      ol {
                        li {
                          list-style: decimal;
                        }
                      }
                      ul {
                        li {
                          list-style: disc;
                        }
                      }
                    }
                  }
                }
              }

              .send-goods-container {
                .send-goods-box {
                  max-width: 320px;
                  margin: 0 auto;
                  background-color: #fff;
                  border-radius: 8px;
                  box-shadow: 0px 4px 21px 0px rgba(0, 0, 0, 0.07);
                  padding: 8px;
                  box-sizing: border-box;

                  .send-goods-info-box {
                    display: block;
                  }

                  .send-goods-image {
                    width: 60px;
                    height: 60px;
                    border-radius: 5px;
                    margin-right: 10px;
                    overflow: hidden;

                    img {
                      display: inline-block;
                      width: 100%;
                      height: 100%;
                      border-radius: 5px;
                    }
                  }

                  .send-goods-info {
                    max-width: 230px;
                    font-size: 13px;

                    .send-goods-title {
                      line-height: 18px;
                      margin-bottom: 10px;
                      color: #333;
                    }

                    .send-goods-price {
                      color: #ff070f;

                      span {
                        padding-left: 3px;
                      }
                    }
                  }

                  .send-goods-btn-wrap {
                    margin-top: 15px;
                    text-align: center;

                    .send-goods-btn {
                      display: inline-block;
                      border: 1px solid #ff070f;
                      border-radius: 15px;
                      color: #ff070f;
                      padding: 10px 20px;
                      box-sizing: border-box;
                      cursor: pointer;
                    }
                  }
                }
              }
            }
          }

          .chat-bottom {
            height: 150px;
            // background-color: #f5f6f7;background-color: #f5f6f7;
            position: relative;
            border-top: 1px solid #dddddd;
            border-right: 1px solid #dddddd;
            box-sizing: border-box;
            background-color: #fff;
            position: relative;
            .chat-operate {
              height: 100%;

              li {
                list-style: none;
              }
            }

            .human-btn {
              display: inline-block;
              font-size: 12px;
              line-height: 23px;
              border:1px solid #dddddd;
              box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);
              border-radius:13px;
              padding:0 6px;
              color: #333;
              position: absolute;
              left: 12px;
              top: -12px;
              transform: translate(0, -100%);
              background: #fff;
              cursor: pointer;
            }

            .chat-input-container {
              position: relative;

              .tools-bar {
                padding: 8px;
                margin: 0;
                box-sizing: border-box;
                height: 40px;

                li {
                  float: left;
                  padding: 3px;
                  box-sizing: border-box;
                  cursor: pointer;

                  .qq_contact {
                    display: inline-block;
                  }
                }
                .recallStyle {
                  width: 200px;
                  font-size: 12px;
                  padding: 2px 0 0 15px;
                  position: relative;
                  float: right;
                  margin-right: 12px;
                  // margin-right: 110px;
                  .recallTips {
                    position: absolute;
                    left: 0;
                    // top: -125px;
                    bottom: 40px;
                    padding: 10px 15px;
                    background: #fff;
                    font-size: 10px;
                    line-height: 24px;
                    // text-align: center;
                    border: 1px solid #eee;
                    border-bottom: 0;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                  }
                  .recallInput {
                    width: 120px;
                    height: 26px;
                    border: 1px solid #ccc;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    background: #f5f6f7;
                    border-right: 0;
                    padding: 0 5px;
                    box-sizing: border-box;
                  }
                  .recallBtn {
                    background: #428efe;
                    color: #fff;
                    height: 26px;
                    line-height: 26px;
                    padding: 6px 5px;
                    border-bottom-right-radius: 5px;
                    border-top-right-radius: 5px;
                    box-sizing: border-box;
                    &:hover {
                      cursor: pointer;
                    }
                  }
                }
              }

              .emoji_pannel {
                width: 100%;
                height: 200px;
                top: -200px;
                overflow-y: scroll;
              }

              .wechat_contact {
                position: absolute;
                background-color: #fff;
                padding: 8px 8px 0;
                border: 1px solid #eee;
                top: -190px;
                left: 10px;
                width: 168px;
                text-align: center;
                box-sizing: border-box;

                .wechat_QRCode {
                  width: 150px;
                  height: 150px;
                  overflow: hidden;

                  img {
                    width: 100%;
                    height: 100%;
                  }
                }

                .close_wechat_contact {
                  height: 24px;
                  line-height: 24px;
                  font-size: 12px;

                  span {
                    cursor: pointer;
                  }
                }
              }
              .inputTextContainer {
                display: flex;
                .sendBtnContainer {
                  position: absolute;
                  bottom:3px;
                  right: 20px;
                  display: flex;
                  width: 60px;
                  height: 30px;
                  align-items: center;
                  justify-content: center;
                  border: 1px solid #d8d9db;
                  border-radius: 15px;
                  cursor: not-allowed;
                  font-size: 14px;
                  color: #d8d9db;
                  background-color: #fff;
                  &.btnActive {
                    background-color: rgb(51, 150, 251);
                    cursor: pointer;
                    color: #fff;
                  }
                }
              }
              .chatTextDiv {
                overflow-y: auto;
                outline: none;
                padding: 8px;
                box-sizing: border-box;
                font-size: 13px;
                height: 70px;
                width: 100%;
                resize: none;
                border: none;
              }

              .chat-send-operate-btn {
                position: absolute;
                bottom: 9px;
                color:#bfc0c1;
                right: 100px;
              }
            }

            .chat-end-container {
              &.black-container {
                position: relative;

                span {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
              }

              .chat-end-operate {
                height: 100%;

                li {
                  float: left;
                  height: 100%;
                  line-height: 1;
                  width: 33.33%;
                  text-align: center;
                  position: relative;
                  color: #707070;
                  font-size: 14px;
                  padding-top: 55px;
                  box-sizing: border-box;

                  & > div {
                    cursor: pointer;
                  }

                  .chat-end-operate-title {
                    display: inline-block;
                    margin-top: 10px;
                  }
                }

                &.no-evaluate {
                  li {
                    width: 50%;
                  }
                }
              }
            }
          }

          .evaluate-pannel {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.3);

            .evaluate-container {
              background-color: #fff;
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              height: 91%;
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
              padding: 15px 15px 5px;
              box-sizing: border-box;
              overflow-y: auto;

              .evaluate-title {
                text-align: center;
                font-size: 16px;
                color: #333;
                position: relative;

                .evaluate-pannel-close {
                  position: absolute;
                  top: 0;
                  right: 0;
                  cursor: pointer;
                }
              }

              .evaluate-level {
                text-align: center;
                padding: 0 0 8px;
                width: 240px;
                margin: 0 auto;
                box-sizing: border-box;
                font-size: 12px;
                color: #666;

                & > div {
                  float: left;
                  cursor: pointer;
                  width: 45px;
                  padding: 10px 0 6px;
                  border: 1px solid #fff;

                  &.chosen {
                    background-color: #fafafa;
                    border: 1px solid #f0f0f0;
                    border-radius: 4px;
                  }
                }

                .level-title {
                  padding-top: 10px;
                  box-sizing: border-box;
                }
              }

              .evaluate-level-name {
                text-align: center;
                font-size: 12px;
                padding-bottom: 5px;
                box-sizing: border-box;

                span {
                  color: #428efe;
                }
              }

              .evaluate-quick-content {
                font-size: 13px;
                padding-bottom: 15px;
                text-align: center;

                span {
                  cursor: pointer;
                  display: inline-block;
                  background-color: #eaf2ff;
                  color: #428efe;
                  padding: 5px 18px;
                  border-radius: 16px;
                  margin-top: 10px;
                  margin-right: 10px;
                }

                &.wrapVery {
                  .tagActive {
                    background-color: #428efe;
                    color: #fff;
                  }
                }

                &.wrapSatisfied {
                  .tagActive {
                    background-color: #428efe;
                    color: #fff;
                  }
                }

                &.wrapNormal {
                  .tagActive {
                    background-color: #428efe;
                    color: #fff;
                  }
                }

                &.wrapLess {
                  .tagActive {
                    background-color: #428efe;
                    color: #fff;
                  }
                }

                &.wrapWorse {
                  .tagActive {
                    background-color: #428efe;
                    color: #fff;
                  }
                }
              }

              .evaluate-content-wrap {
                /*height: 35%;*/
              }

              .evaluate-content {
                resize: none;
                width: 100%;
                border: 1px solid #e5e5e5;
                font-size: 12px;
                border-radius: 4px;
                padding: 8px;
                height: 100%;
                outline: none;
                line-height: 16px;
                box-sizing: border-box;
              }

              .evaluate-submit {
                text-align: center;
                padding-top: 15px;

                span {
                  width: 80%;
                  display: inline-block;
                  padding: 10px 15px;
                  text-align: center;
                  font-size: 14px;
                  color: #fff;
                  cursor: pointer;
                  background-color: #488bff;
                  border-radius: 5px;

                  &.btnDisabled {
                    background-color: #dae4ed;
                    cursor: not-allowed;
                  }
                }
              }
            }
          }
        }

        .leave-msg-container {
          height: $mainHeight;
          overflow-y: auto;

          .leave-msg-main {
            padding: 15px;
            box-sizing: border-box;

            .leave-msg-tips {
              color: #8a9099;
              font-size: 14px;
              line-height: 22px;
              word-break: break-all;
            }

            .form-item {
              margin-top: 15px;

              .item-title {
                font-size: 14px;
                color: #8fa1b2;

                span {
                  color: red;
                }
              }

              .item-content {
                width: 100%;
                border: 1px solid #eee;
                border-radius: 4px;
                line-height: 40px;
                outline: none;
                padding: 0 8px;
                box-sizing: border-box;
                margin-top: 5px;

                &.problem-detail {
                  resize: none;
                  line-height: 20px;
                  height: 100px;
                  overflow: auto;
                  padding: 8px;
                  box-sizing: border-box;
                }
              }
            }

            .leave-msg-submit {
              text-align: center;
              padding-top: 15px;

              span {
                display: inline-block;
                width: 180px;
                height: 40px;
                line-height: 40px;
                border-radius: 5px;
                text-align: center;
                color: #fff;
                cursor: pointer;
                background-color: #488bff;

                &.btnDisabled {
                  background-color: #dae4ed;
                  cursor: not-allowed;
                }
              }
            }
          }
        }

        .lineup-container {
          height: calc(100% - 50px);

          .lineup-main {
            height: calc(100% - 50px);
            padding: 15px 10px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;

            .lineup-tips {
              font-size: 13px;
              line-height: 22px;
              padding-bottom: 20px;
              box-sizing: border-box;
              height: 65px;
              max-height: 100px;
              overflow-y: auto;
            }

            .lineup-count {
              flex: 1;
              display: flex;
              flex-direction: column;
              text-align: center;
              border-top: 1px solid #eee;
              border-bottom: 1px solid #eee;
              padding: 20px 0;
              box-sizing: border-box;
              justify-content: center;
              color: #3396fa;

              .count-tips {
              }

              .count-num {
                font-size: 40px;
                font-weight: bold;
                margin-top: 20px;

                span {
                  font-size: 13px;
                  font-weight: normal;
                  padding-left: 6px;
                }
              }
            }

            .lineup-operation {
              height: 90px;
              padding-top: 30px;
              box-sizing: border-box;
              text-align: center;
              font-size: 13px;

              .to-leave-msg-btn {
                background-color: #3396fa;
                color: #fff;
                padding: 10px 0;
                width: 150px;
                margin: 10px auto 0;
                border-radius: 5px;
                box-sizing: border-box;
              }
            }
          }
        }
      }
      .rightContaienr {
        width: 194px;
        background: #fff;
        display: flex;
        flex-direction: column;
        .swipeImageContainer {
          flex: 1;
          overflow: hidden;
          padding: 0 8px;
          box-sizing: border-box;
          .el-carousel {
            height: 100%;
            display: flex;
            flex-direction: column;
            .el-carousel__item {
              display: flex;
              align-items: center;
              img {
                max-width: 100%;
                max-height: 100%;
                vertical-align: middle;
                cursor: pointer;
              }
            }
            .el-carousel__indicators {
              display: none;
            }
          }
        }
        .toolBoxTitle {
          text-align: center;
          color: #666666;
          font-size: 14px;
          padding: 10px 0;
          display: none;
          align-items: center;
          width: 100%;
          justify-content: center;
          .text {
            padding: 0 5px;
          }
          .line {
            border: 0.5px solid #eeeeee;
            display: inline-block;
            width: 25%;
            height: 0px;
          }
        }
        .toolBox {
          display: none;
          flex-wrap: wrap;
          align-items: center;
          height: 200px;
          .toolItem {
            width: 50%;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 50px;
            cursor: pointer;
            a {
              display: inline-block;
            }
            .itemIcon {
              width: 24px;
              height: 24px;
              margin: 0 auto;
              overflow: hidden;
              border-radius: 50%;
              background: cornflowerblue;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .itemName {
              font-size: 14px;
              color: #666666;
              margin-top: 6px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding: 8px;
              text-align: center;
              box-sizing: border-box;
            }
          }
        }
      }
    }
    .tech-support {
      position: absolute;
      bottom: 5px;
      left: 10px;
      height: 20px;
      font-size: 12px;
      color: #bdbdbd;
    }
  }
}
</style>
